import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';


const ContactSupport = () => {
  const [feedbackSubmitted, setFeedbackSubmitted] = useState(false);
  const [feedbackText, setFeedbackText] = useState('');

  const handleFeedbackSubmit = (e) => {
    e?.preventDefault();
    // In a real app, this would send feedback to a server
    setFeedbackSubmitted(true);
    setTimeout(() => {
      setFeedbackSubmitted(false);
      setFeedbackText('');
    }, 3000);
  };

  return (
    <div className="bg-card rounded-lg shadow-warm-md p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-primary/20 rounded-lg flex items-center justify-center">
          <Icon name="headphones" size={20} className="text-primary" />
        </div>
        <div>
          <h2 className="text-h3 font-heading text-foreground">Contact Support</h2>
          <p className="text-sm text-muted-foreground">Still need help? We're here for you</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Support Options */}
        <div className="space-y-4">
          <div className="bg-muted/30 rounded-lg p-4">
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 bg-blue-100 dark:bg-blue-900/30 rounded-lg flex items-center justify-center flex-shrink-0">
                <Icon name="mail" size={16} className="text-blue-600 dark:text-blue-400" />
              </div>
              <div className="flex-1">
                <h3 className="font-semibold text-foreground mb-1">Email Support</h3>
                <p className="text-sm text-muted-foreground mb-2">
                  Get help via email within 24 hours
                </p>
                <a
                  href="mailto:support@familysync.com"
                  className="text-sm text-primary hover:underline"
                >
                  support@familysync.com
                </a>
              </div>
            </div>
          </div>

          <div className="bg-muted/30 rounded-lg p-4">
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 bg-green-100 dark:bg-green-900/30 rounded-lg flex items-center justify-center flex-shrink-0">
                <Icon name="users" size={16} className="text-green-600 dark:text-green-400" />
              </div>
              <div className="flex-1">
                <h3 className="font-semibold text-foreground mb-1">Community Forums</h3>
                <p className="text-sm text-muted-foreground mb-2">
                  Connect with other families and share tips
                </p>
                <Button variant="link" size="sm" className="p-0 h-auto">
                  Visit Forums →
                </Button>
              </div>
            </div>
          </div>

          <div className="bg-muted/30 rounded-lg p-4">
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 bg-purple-100 dark:bg-purple-900/30 rounded-lg flex items-center justify-center flex-shrink-0">
                <Icon name="video" size={16} className="text-purple-600 dark:text-purple-400" />
              </div>
              <div className="flex-1">
                <h3 className="font-semibold text-foreground mb-1">Video Tutorials</h3>
                <p className="text-sm text-muted-foreground mb-2">
                  Watch step-by-step guides and demos
                </p>
                <Button variant="link" size="sm" className="p-0 h-auto">
                  Watch Videos →
                </Button>
              </div>
            </div>
          </div>
        </div>

        {/* Feedback Form */}
        <div>
          <div className="bg-muted/30 rounded-lg p-4">
            <h3 className="font-semibold text-foreground mb-3">Send Feedback</h3>
            {feedbackSubmitted ? (
              <div className="text-center py-8">
                <div className="w-12 h-12 bg-success/20 rounded-full flex items-center justify-center mx-auto mb-3">
                  <Icon name="check" size={24} className="text-success" />
                </div>
                <p className="text-success font-medium">Thank you for your feedback!</p>
                <p className="text-sm text-muted-foreground mt-1">
                  We appreciate your input and will review it shortly.
                </p>
              </div>
            ) : (
              <form onSubmit={handleFeedbackSubmit} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-foreground mb-2">
                    How can we improve?
                  </label>
                  <textarea
                    value={feedbackText}
                    onChange={(e) => setFeedbackText(e?.target?.value)}
                    placeholder="Share your thoughts, suggestions, or report issues..."
                    className="w-full h-32 px-3 py-2 rounded-md border border-input bg-background text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring resize-none"
                    required
                  />
                </div>
                <Button type="submit" fullWidth iconName="send">
                  Submit Feedback
                </Button>
              </form>
            )}
          </div>
        </div>
      </div>

      {/* Help Article Rating */}
      <div className="mt-6 pt-6 border-t border-border">
        <p className="text-sm text-muted-foreground text-center mb-3">
          Was this help center useful?
        </p>
        <div className="flex justify-center gap-2">
          <Button variant="outline" size="sm" iconName="thumbs-up">
            Yes, helpful
          </Button>
          <Button variant="outline" size="sm" iconName="thumbs-down">
            Needs improvement
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ContactSupport;